import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
// FB 7111
import {
  Button,
  createTheme,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { EMRConfig, Guardian, DeleteGuardian } from "../../../store";
import UseStyle from "../../../css/styles";
import {
  AccountDisabling,
  GetGuardianAccounts,
  InsertPPLogs,
  RegisterGuardian,
} from "../../../api";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react" //FB 7045 KK
//FB 7111
import StrengthMeter from "../../../components/PasswordStrengthMeter";
import { CheckCircle } from "@mui/icons-material";


// Update log
// FB  6192   02/06/2023  DK  Added page to handle Guardian access
// FB  6919   06/02/2023  SK  PP (Account access page) -- On Click on clear button only DOB field is getting clear.
// FB  7045   07/19/2023  KK  PP- Unable to enter Date fields manually
// FB  7111   07/25/2023  DK  Password strength meter and green tick feature
// FB  7239   08/17/2023  KK  PP- DOB when entered manually is not taken into account
// FB  7528   10/05/2023  DK  Issue with DOB field (Picking a day earlier)
// FB  8481   04/04/2024  KI  Restrict user to create account with only space

export default function AccountAuth() {
  const [check, setChecked] = useState(false);
  const [accountArray, setAccountArray] = useState<Array<AccountProps>>([]);
  const [isCriteriaMet, setIsCriteriaMet] = useState(false);  //FB 7111
  type AccountProps = {
    auth_FirstName: string;
    auth_LastName: string;
    auth_Login: string;
  };
  const matches = useMediaQuery("(min-width:600px)");
  const stylesbegin = {
    container: {
      marginLeft: matches == false ? "20px" : "90px",
      marginTop: "40px",
      paddingBottom: "25px",
      width: matches == false ? "90%" : "900px",
    },
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#083A4D",
      },
    },
  });
  const styles = UseStyle();
  var JSAlert = require("js-alert");
  const navigate = useNavigate();
  var intialState: Guardian = {} as Guardian;
  intialState.Auth_DOB = null as unknown as Date;
  //FB 6919 - Start
  intialState.Auth_FirstName = "";
  intialState.Auth_DOB = null as unknown as Date;
  intialState.Auth_LastName = "";
  intialState.Auth_Login = "";
  intialState.relation = "";
  intialState.password = "";
  intialState.WebsiteID = 0;
  intialState.PatientLogin = "";
  intialState.patientid = 0;
  intialState.PatientAccessCode = "";
  //FB 6919 - Stop

  const [guardian, setGuardian] = useState(intialState);
  var startState: DeleteGuardian = {} as DeleteGuardian;
  const [disabledGuardian, setDisabledGuardian] = useState(startState);
  const [password2, setPassword2] = useState("");
  const [errors, setErrors] = useState<any>({});
  const handleInputChange = (e: any) => {
    if (!isNaN(Date.parse(e))) {
      setErrors({ PatientDOB: false });
      setGuardian({ ...guardian, Auth_DOB: e });
    } else {
      setErrors({ [e.target.name]: false });
      setGuardian({ ...guardian, [e.target.name]: e.target.value });
    }
  };
  const handleDateChange = async (date: any) => {
    if (date != null && date != "Invalid Date") {
      //FB 7528
      handleInputChange(date); // FB 7239 KK
    }
  };

  function ValidateForm() {
    //FB 8481 added trim for firstName and lastName
    if (
      guardian.Auth_FirstName == undefined ||
      guardian.Auth_FirstName.trim() === "" 
    ) {
      setErrors((errors: any) => ({ ...errors, Auth_FirstName: true }));
      return false;
    }
    if (guardian.Auth_LastName == undefined || guardian.Auth_LastName.trim() === "") {
      setErrors((errors: any) => ({ ...errors, Auth_LastName: true }));
      return false;
    }
    if (guardian.relation == undefined || guardian.relation === "") {
      setErrors((errors: any) => ({ ...errors, relation: true }));
      return false;
    }
    if (guardian.Auth_DOB == undefined || guardian.Auth_DOB.toString() == "") {
      setErrors((errors: any) => ({ ...errors, Auth_DOB: true }));
      return false;
    }
    if (guardian.Auth_Login == undefined || guardian.Auth_Login === "") {
      setErrors((errors: any) => ({ ...errors, Auth_Login: true }));
      return false;
    } else {
      if (!/\S+@\S+\.\S+/.test(guardian.Auth_Login)) {
        JSAlert.alert(
          "Please enter a valid email id",
          null,
          JSAlert.Icons.Failed
        );
        setErrors((errors: any) => ({ ...errors, Auth_Login: true }));
        return false;
      }
    }
    //FB 7111
    var regex = RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\\s])(?=.{8,})");
    if (guardian.password == undefined || guardian.password === "") {
      setErrors((errors: any) => ({ ...errors, password: true }));
      return false;
    } else if (password2 == undefined || password2 === "") {
      setErrors((errors: any) => ({ ...errors, password2: true }));
      return false;
    } else {
      if (!guardian.password.match(regex)) {
        JSAlert.alert(
          "Password doesn't match the criteria",
          null,
          JSAlert.Icons.Failed
        );
        setErrors((errors: any) => ({
          ...errors,
          password: true,
          password2: true,
        }));
        return false;
      }
      if (!(guardian.password === password2)) {
        JSAlert.alert(
          "Entered passwords doesn't match",
          null,
          JSAlert.Icons.Failed
        );
        setErrors((errors: any) => ({
          ...errors,
          password: true,
          password2: true,
        }));
        return false;
      }
    }
    return true;
  }
  const GetAccDetails = async () => {
    var datalocal = sessionStorage.getItem("user");
    if (datalocal != null) {
      const user = JSON.parse(datalocal);
      var data = await GetGuardianAccounts(user.Patient_n);
      setAccountArray(data);

      if (data.length == 0) {
        setChecked(false);
      } else {
        setChecked(true);
      }
    }
  };
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    userName = JSON.parse(data).Login;
  }

  const handleDelete = async (evt: any) => {
    let obj = sessionStorage.getItem("EMRConfig");
    if (obj != null) {
      let emrConfig = JSON.parse(obj) as EMRConfig;
      disabledGuardian.WebsiteID = emrConfig.WebsiteID;
      let user = sessionStorage.getItem("user");

      if (user != null) {
        disabledGuardian.patientid = JSON.parse(user).Patient_n;
        disabledGuardian.Auth_Login = evt.auth_Login;

        const response = await AccountDisabling(disabledGuardian);
        if (response != undefined) {
          if (response.alertType == "Success") {
            InsertPPLogs(
              "Deleted Guardian" +
                " " +
                evt.auth_FirstName +
                " " +
                evt.auth_LastName,
              window.location.href,
              userName,
              ""
            );
            JSAlert.alert(
              "Account Deleted Successfully",
              null,
              JSAlert.Icons.Success
            ).then(function () {
              navigate("/user/home/dashboard");
            });
          }
        }
      }
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (ValidateForm()) {
      let obj = sessionStorage.getItem("EMRConfig");
      if (obj != null) {
        let emrConfig = JSON.parse(obj) as EMRConfig;
        guardian.WebsiteID = emrConfig.WebsiteID;
        let user = sessionStorage.getItem("user");
        if (user != null) {
          guardian.PatientAccessCode = JSON.parse(user).Patient_n.toString();
          guardian.patientid = JSON.parse(user).Patient_n;
          guardian.PatientLogin = JSON.parse(user).Login;
          guardian.active_flag = true;
          const response = await RegisterGuardian(guardian);
          if (response != undefined) {
            if (response.alertType == "Success") {
              JSAlert.alert(response.message, null, JSAlert.Icons.Success).then(
                function () {
                  navigate("/user/home/dashboard");
                }
              );
            } else {
              JSAlert.alert(response.message, null, JSAlert.Icons.Failed).then(
                function () {
                  window.location.reload();
                }
              );

              // function () {
              //   // setGuardian(intialState);
              //   setGuardian({
              //     ...guardian,
              //     PatientAccessCode: "",
              //     patientid: 0,
              //     PatientLogin: "",
              //     WebsiteID: 0,
              //     Auth_Login: "",
              //     Auth_FirstName: "",
              //     Auth_LastName: "",
              //     password: "",
              //     relation: "",
              //     // Auth_DOB: "",
              //     active_flag: 0,
              //   });
              //   setPassword2("");
              // }
            }
          }
        }
      }
    }
  };
  const handleClear = () => {
    setGuardian(intialState);
  };
  const stylestart = {
    container: {
      border: "1px grey",
      backgroundColor: "#F8F8F8",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  };

  useEffect(() => {
    GetAccDetails();
  }, []);
  return (
    <form onSubmit={handleSubmit}>
      <div className="card">
        <div className="col-sm-12" style={stylestart.container}>
          <label
            style={{
              color: "black",
              fontSize: "32px",
              fontWeight: "700",
              lineHeight: "40px",
              marginLeft: matches == false ? "20px" : "70px",
              marginRight: matches == false ? "20px" : "0px",
            }}
          >
            Account Authorization
          </label>
        </div>
        <div className="row" style={{ marginBottom: "20px" }}>
          <div className="card " style={stylesbegin.container}>
            <div
              className="card-text"
              style={{
                paddingTop: "20px",
                textAlign: "left",
                marginLeft: matches == false ? "20px" : "50px",
              }}
            >
              <TextField
                variant="outlined"
                name="Auth_FirstName"
                label="First Name"
                value={guardian.Auth_FirstName}
                onChange={handleInputChange}
                error={errors.Auth_FirstName}
                style={{ width: matches == false ? "95%" : "400px" }}
                required
              />{" "}
              <br></br>
              <br></br>
              <TextField
                variant="outlined"
                name="Auth_LastName"
                label="Last Name"
                value={guardian.Auth_LastName}
                onChange={handleInputChange}
                error={errors.Auth_LastName}
                style={{ width: matches == false ? "95%" : "400px" }}
                required
              />{" "}
              <br></br>
              <br></br>
              <FormControl
                required
                style={{ width: matches == false ? "95%" : "400px" }}
              >
                <InputLabel id="demo-simple-select-label">Relation</InputLabel>
                <Select
                  id="standard-basic"
                  value={guardian.relation}
                  onChange={handleInputChange}
                  error={errors.relation}
                  label="Relation"
                  name="relation"
                >
                  <MenuItem value="Brother">Brother</MenuItem>
                  <MenuItem value="Sister">Sister</MenuItem>
                  <MenuItem value="Father">Father</MenuItem>
                  <MenuItem value="Mother">Mother</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>{" "}
              <br></br>
              <br></br>
              {/* FB 7045 KK Begin */}
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    InputLabelProps={{ shrink: true }}
                    id="Auth_DOB"
                    name="Auth_DOB"
                    label="Date of Birth"
                    className={styles.datepickerroot}
                    style={{ width: matches == false ? "95%" : "400px" }}
                    value={guardian.Auth_DOB}
                    format="MM/dd/yyyy"
                    placeholder="MM/dd/yyyy"
                    openTo="year"
                    views={["year", "month", "date"]}
                    onChange={(date) => handleDateChange(date)}
                    inputVariant="standard"
                    orientation="portrait"
                    disableFuture
                    required
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>{" "}
              {/* FB 7045 KK End */}
              <br></br>
              <br></br>
              <TextField
                variant="outlined"
                name="Auth_Login"
                label="Email(Userid)"
                value={guardian.Auth_Login}
                error={errors.Auth_Login}
                onChange={handleInputChange}
                style={{ width: matches == false ? "95%" : "400px" }}
                required
              />{" "}
              <br></br>
              <br></br>
              <TextField
                type="password"
                variant="outlined"
                name="password"
                label="Password"
                value={guardian.password}
                error={errors.password}
                onChange={handleInputChange}
                style={{ width: matches == false ? "95%" : "400px" }}
                required
                // FB 7111
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <CheckCircle style={{ color: isCriteriaMet ? "green" : "lightgray" }} />
                    </InputAdornment>
                  ),
                }}
              />{" "}
              {/* FB 7111 */}
              <StrengthMeter width={400} password={guardian.password} setIsCriteriaMet={setIsCriteriaMet} />
              <br></br>
              <br></br>
              <TextField
                type="password"
                variant="outlined"
                name="password"
                label="Confirm Password"
                value={password2}
                error={errors.password2}
                onChange={(e) => {
                  setPassword2(e.target.value);
                }}
                style={{ width: matches == false ? "95%" : "400px" }}
                required
              />{" "}
              <br></br>
              <br></br>
              <Grid item xs={12}>
                <h5>Passwords must include:</h5>
                <ul className="list">
                  <li>Eight or more characters</li>
                  <li>At least one upper and lower case character</li>
                  <li>At least one number</li>
                  {/* FB 7111 */}
                  <li>At least one special character</li>
                </ul>
              </Grid>
              <Button
                type="submit"
                className={styles.navigationButton}
                //onClick={handleSubmit}
              >
                Allow Access
              </Button>{" "}
              &nbsp;&nbsp;
              <Button className={styles.navigationButton} onClick={handleClear}>
                Clear
              </Button>{" "}
            </div>
          </div>
        </div>

        {check && (
          <div
            className="col-sm-12"
            style={{
              marginLeft: matches == false ? "10px" : "80px",
              paddingBottom: "25px",
              width: matches == false ? "95%" : "900px",
            }}
          >
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>First Name</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Last Name</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Login</strong>&nbsp;
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {accountArray.map((x) => (
                    <TableRow
                      key={x.auth_FirstName}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="left">{x.auth_FirstName}</TableCell>
                      <TableCell align="left">{x.auth_LastName}</TableCell>
                      <TableCell align="left">{x.auth_Login}</TableCell>
                      <TableCell>
                        <Button style={{ color: "red" }}>
                          {" "}
                          <DeleteIcon onClick={() => handleDelete(x)} />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </form>
  );
}
